import { render, staticRenderFns } from "./order.vue?vue&type=template&id=58042643&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58042643",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58042643')) {
      api.createRecord('58042643', component.options)
    } else {
      api.reload('58042643', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=58042643&scoped=true&", function () {
      api.rerender('58042643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/order/order.vue"
export default component.exports